import { useTranslation } from "react-i18next";
import useLanguage from "../../hooks/useLanguage";
import {
  AppHeader,
  AppAppHeaderItem,
  Avatar,
  DropDownMenu,
  Link
} from "@etframework/ui.components";
import useRolePermissionStore from "../../store/rolePermissionStore";
import { useNavigate } from "react-router-dom";
import useModalEvent from "../../hooks/useModalEvent";
import { useAppLogout } from "../../hooks/useAppLogout";
import { useDueDatesAuth } from "../../hooks/useDueDatesAuth";
import { IsSubscriptionValid } from "../../utils/helpers";

const DueDatesAppHeader = () => {
  const navigate = useNavigate();
  const logout = useAppLogout();
  const clientsUrl = import.meta.env.PUBLIC_APP_CRM_URL;
  const portalUrl = import.meta.env.PUBLIC_APP_PORTAL_URL;

  const { currentLang, toggleLanguage } = useLanguage();
  const { ModalEvents, toggleModal } = useModalEvent();
  const { t } = useTranslation(["Layout"], {
    useSuspense: false
  });

  const { UserFullName } = useDueDatesAuth();
  const validSub = IsSubscriptionValid();

  const rolePermissions = useRolePermissionStore(
    (state) => state.rolePermissions
  );

  let items = [
    {
      id: "account",
      text: t("AvatarDropDownMenu.MyAccount"),
      onClick: () => {
        window.location.href = import.meta.env.PUBLIC_ACCOUNT_URL;
      }
    },
    {
      id: "notifications",
      text: t("AvatarDropDownMenu.Notifications"),
      onClick: () => {
        navigate("/duedates/notifications/notificationpreferences");
      }
    },
    {
      separator: true
    },
    {
      id: "lang",
      text: t("AvatarDropDownMenu.Language")
    },
    {
      id: "en",
      iconCss: currentLang == "en" ? "fa-solid fa-check" : "",
      text: t("AvatarDropDownMenu.English"),
      onClick: () => {
        toggleLanguage();
      }
    },
    {
      id: "es",
      iconCss: currentLang == "es" ? "fa-solid fa-check" : "",
      text: t("AvatarDropDownMenu.Spanish"),
      onClick: () => {
        toggleLanguage();
      }
    },
    {
      separator: true
    },
    {
      id: "help",
      text: t("AvatarDropDownMenu.Help"),
      onClick: () => {
        window.open("https://support.experttax.com/", "_blank");
      }
    },
    {
      id: "new-on-duedates",
      text: t("AvatarDropDownMenu.NewOnDueDates"),
      onClick: () => {
        toggleModal(ModalEvents.WelcomeModal);
      }
    },
    {
      id: "signout",
      text: t("AvatarDropDownMenu.SignOut"),
      onClick: async () => {
        logout();
      }
    }
  ];

  const onSelectAvatarDropDownMenu = (args) => {
    args?.onClick?.();
  };

  const beforeItemRender = (args) => {
    const element = args.element;

    if (args.item.id === "lang")
      element.setAttribute("class", "avatar-dropdown-menu-header");

    if (args.item.id === "en" || args.item.id === "es")
      element.classList.add("class", "avatar-dropdown-icons");

    if (
      args.item.id === "account" ||
      args.item.id === "notifications" ||
      args.item.id === "help" ||
      args.item.id === "new-on-duedates" ||
      args.item.id === "signout"
    )
      element.classList.add("class", "avatar-dropdown-menu-item");
  };

  const headerIcons = (
    <div className="d-flex icon-buttons">
      {rolePermissions.CanAccessSettings && validSub ? (
        <div
          className={`settings-icon-button ${
            location.pathname.includes("/duedates/settings")
              ? "avatar-dropdown-menu-active"
              : ""
          }`}
        >
          <Link
            to="/duedates/settings/boards"
            type="icon"
            iconCss="fa-solid fa-gear et-white"
          ></Link>
        </div>
      ) : null}
      <div className="avatar-dropdown-menu">
        <DropDownMenu
          id="avatar-dropdown-menu"
          items={items}
          hideChevron={true}
          beforeItemRender={beforeItemRender}
          select={onSelectAvatarDropDownMenu}
        >
          <Avatar content={UserFullName}></Avatar>
        </DropDownMenu>
      </div>
    </div>
  );

  return (
    <AppHeader imgUri="/expert-practice-logo.svg" icons={headerIcons}>
      <AppAppHeaderItem text={t("Header.Portal")} url={portalUrl} />
      <AppAppHeaderItem text={t("Header.Clients")} url={clientsUrl} />
      <AppAppHeaderItem
        isActive={
          location.pathname.includes("/duedates/views") ||
          location.pathname.includes("/duedates/welcome")
            ? true
            : false
        }
        text={t("Header.DueDates")}
        url="/duedates/views/assignedtome"
      />
    </AppHeader>
  );
};

export default DueDatesAppHeader;
